export const NumInput = ({ l, v, fn, pre = "$", c }) => (
  <div>
    <div style={{ fontSize: 12, color: c.muted, marginBottom: 5, fontWeight: 500 }}>{l}</div>
    <div style={{
      display: "flex", alignItems: "center", gap: 4,
      border: "1px solid " + c.border, borderRadius: 10,
      padding: "8px 12px", background: c.inputBg, transition: "border-color 0.2s",
    }}>
      {pre && <span style={{ color: c.muted, fontSize: 13 }}>{pre}</span>}
      <input type="number" value={v}
        onChange={(e) => fn(Number(e.target.value) || 0)}
        style={{
          border: "none", background: "transparent", color: c.fg,
          fontSize: 14, fontWeight: 600, width: "100%", outline: "none",
          fontVariantNumeric: "tabular-nums",
        }} />
    </div>
  </div>
);
